/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Round_Time_DescInputs */



/**
* | output |
* | --- |
* | "minutes (0 = no timer)" |
*
* @param {Og_Cfg_Round_Time_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_round_time_desc = /** @type {((inputs?: Og_Cfg_Round_Time_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Round_Time_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("minutes (0 = pas de chronomètre)")
	if (locale === "es") return /** @type {LocalizedString} */ ("minutos (0 = sin temporizador)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("minutos (0 = sem cronômetro)")
	if (locale === "it") return /** @type {LocalizedString} */ ("minuti (0 = nessun timer)")
	return /** @type {LocalizedString} */ ("minutes (0 = no timer)")
});